function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: none;\n  margin: 0;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { newStyled } from "./chunk-QHXULKU4.mjs";
// src/components/Divider/Divider.style.ts
function getDividerStyle(size, color, orientation, isFlexItem) {
    return ({
        horizontal: {
            width: "100%",
            borderTop: "".concat(size, "px solid ").concat(color)
        },
        vertical: {
            height: isFlexItem ? "auto" : "100%",
            borderLeft: "".concat(size, "px solid ").concat(color),
            alignSelf: isFlexItem ? "stretch" : "auto"
        }
    })[orientation];
}
var Divider = newStyled.hr(_templateObject(), function(param) {
    var size = param.size, color = param.color, orientation = param.orientation, isFlexItem = param.isFlexItem;
    return getDividerStyle(size, color, orientation, isFlexItem);
});
export { Divider };
